import React from 'react';
import Sidebar from '../component/layout/sidebar';
import Header from '../component/layout/header';
import { useState } from 'react';
import Categoriescontent from '../sections/categories-content';


const Categories = () => {
         const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    return ( 
         <section className='main-dashboard-container'>            
            <Sidebar isOpen={isSidebarOpen}  /> 
            <section className='container-right-info'>
                    <section className='header-container'>
                        <Header  onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}  />
                    </section>

                <Categoriescontent />
                      


            </section>
    </section>


     );
}
 
export default Categories;